type InfiniteLandingGlowLineBaseProps = {
  className?: string
}

export const InfiniteLandingGlowLineBase = ({ className = '' }: InfiniteLandingGlowLineBaseProps) => {
  return <img src='/images/infinite/glow_line_base.png' alt='' className={`h-full w-full max-w-none ${className}`.trim()} />
}
